import type {
  EditAsideWebBannerCallToAction,
  EditAsideWebBannerSubtitle,
  EditAsideWebBannerTitle,
  EditAsideWebBannerUrl,
  EditAsideWebPath,
} from '@nodeTypeConfig/configTypes';
import { updateWebsiteConfigurationActionNew } from '@store/actions/documentActions';
import { get } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentWebConfig } from '../../../hooks/UseCurrentWebConfig';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import SimpleInput from '../asideSimpleInput/SimpleInput';
import { selectIsBannerReadonly } from './asideWebSimpleInputSelectors';

const AsideWebSimpleInput: React.FC<{
  config:
    | EditAsideWebPath
    | EditAsideWebBannerTitle
    | EditAsideWebBannerSubtitle
    | EditAsideWebBannerCallToAction
    | EditAsideWebBannerUrl;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentWebConfig = useCurrentWebConfig();
  const initialValue = get(currentWebConfig, config.property, '');

  const componentReadOnly = useTypedSelector(
    (state) => readonly || selectIsBannerReadonly(state, config),
  );

  const change = (value: string) => {
    dispatch(updateWebsiteConfigurationActionNew(editHref, config.property, value));
  };

  return (
    <SimpleInput
      defaultValue={initialValue}
      label={config.label}
      readOnly={componentReadOnly}
      onChange={change}
    />
  );
};

AsideWebSimpleInput.displayName = 'AsideWebSimpleInput';

export default AsideWebSimpleInput;

AsideWebSimpleInput.propTypes = {
  config: any,
  readonly: any,
};
